module.exports = __webpack_public_path__ + "static/docupop_logo-e2dd63be53d3d6d729861dbfe505c64c.png";